"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSeatedProductOwned = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _q = _interopRequireDefault(require("q"));

var _getHasHigherTieredProduct = require("self-service-api/api/getHasHigherTieredProduct");

var _getIsProductOwned = require("self-service-api/api/getIsProductOwned");

var _getMerchandiseIdOwned = require("self-service-api/api/getMerchandiseIdOwned");

var _MerchandiseIdLists = require("self-service-api/constants/MerchandiseIdLists");

var _productProperties = _interopRequireDefault(require("ui-addon-upgrades/_core/common/constants/productProperties"));

var _products = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/products");

var getSeatedProductOwned = function getSeatedProductOwned() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      upgradeProduct = _ref.upgradeProduct,
      product = _ref.product;

  if (product !== _products.productTypes.SALES && product !== _products.productTypes.SERVICE) {
    return _q.default.Promise.resolve(null);
  }

  var productProperty = _productProperties.default[upgradeProduct];

  if (!productProperty || !productProperty.merchandiseId || !_MerchandiseIdLists.SEATED_MERCHANDISE_ID_TIERS[productProperty.merchandiseId]) {
    return _q.default.Promise.resolve(null);
  }

  var merchandiseId = productProperty.merchandiseId;
  var seatedMerchandiseIdTier = _MerchandiseIdLists.SEATED_MERCHANDISE_ID_TIERS[merchandiseId];
  return (0, _getIsProductOwned.getIsProductOwned)(merchandiseId).then(function (isProductOwned) {
    return isProductOwned ? merchandiseId : _q.default.Promise.all([(0, _getHasHigherTieredProduct.getHasHigherTieredProduct)(merchandiseId), (0, _getMerchandiseIdOwned.getMerchandiseIdOwned)(seatedMerchandiseIdTier)]).then(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          hasHigherTieredProduct = _ref3[0],
          merchIdOwned = _ref3[1];

      if (hasHigherTieredProduct && merchIdOwned) return merchIdOwned;
      return null;
    });
  }).catch(function () {
    return null;
  });
};

exports.getSeatedProductOwned = getSeatedProductOwned;